var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#999","fillRule":"evenodd","d":"M19.25,8 C22.9765625,8 26,11.0234375 26,14.75 C26,18.4765625 22.9765625,21.5 19.25,21.5 C17.9140625,21.5 16.6835938,21.1220703 15.6464844,20.4541016 L10.5664062,25.5605469 C10.2675781,25.8505859 9.87207031,26 9.50292969,26 C9.10742188,26 8.72949219,25.8505859 8.43945312,25.5605469 C7.85058594,24.9804688 7.85058594,24.0224609 8.43945312,23.4335938 L13.5458984,18.3535156 C12.8779297,17.3164062 12.5,16.0859375 12.5,14.75 C12.5,11.0234375 15.5234375,8 19.25,8 Z M19.25,19.25 C21.7285156,19.25 23.75,17.2285156 23.75,14.75 C23.75,12.2714844 21.7285156,10.25 19.25,10.25 C16.7714844,10.25 14.75,12.2714844 14.75,14.75 C14.75,17.2285156 16.7714844,19.25 19.25,19.25 Z","transform":"translate(-8 -8)"}));
}

SearchIcon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
